import { render, staticRenderFns } from "./choseCoupon.vue?vue&type=template&id=53a3b863&"
import script from "./choseCoupon.vue?vue&type=script&lang=js&"
export * from "./choseCoupon.vue?vue&type=script&lang=js&"
import style0 from "./choseCoupon.vue?vue&type=style&index=0&id=53a3b863&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports